import { baseThemeData } from "./baseTheme";

const baseSIThemeData = {
  ...baseThemeData,
  colors: {
    ...baseThemeData.colors,
    brandColor: "#e63422",
    primary: "#E63422",
    textColorBtnContained: "#fff",
    ColorBtnContainedHoover: "#e63422",
    textColorBtnOutlinedMobile: "#E63422",
    textColorBtnContainedMobile: "#E63422",
    headerButtonPrimaryMobile: "#FFFFFF",
    cashierMobileLabel: "#FFFFFF",
    cashierMobileIcon: "#000000"
  },
  typography: {
    fontFamily: "IndustryBook, Arial, sans-serif",
    fontFamilyBold: "IndustryBold, Arial, sans-serif",
    fontFamilyDefaultBold: "IndustryBold",
    fontSizeMobile: `1.1rem`,
    fontWeightMobile: 400
  },
  borders: {
    borderColorMobile: "#FFFFFF"
  }
};

const computePanelThemeData = () => {
  return {
    panel: {
      header: {
        icon: { defaultColor: "#717171" },
        title: {
          defaultColor: baseSIThemeData.textColor
        },
        description: {
          defaultColor: "#717171"
        }
      }
    }
  };
};

const computeExpandablePanelThemeData = () => {
  return {
    expandablePanel: {
      before: {
        borderTopColor: "#2c2c2c",
        boxShadow: "0px -1px 0px 0px",
        boxShadowColor: "#171717"
      },
      header: {
        icon: { defaultColor: baseSIThemeData.colors.iconColor },
        title: {
          defaultColor: baseSIThemeData.textColor,
          expandedColor: baseSIThemeData.textColor
        },
        arrow: {
          defaultColor: baseSIThemeData.textColor,
          expandedColor: baseSIThemeData.textColor
        }
      }
    }
  };
};

const computeListThemeData = () => {
  return {
    list: {
      item: {
        borderBottomColor: "rgb(23, 23, 23)",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#2c2c2c",
        text: { defaultColor: "#cccccc" },
        checkbox: {
          checkedBackground: "#e63422",
          unCheckedBackground: "#000000",
          defaultColor: "#000000"
        }
      }
    }
  };
};

const computeCheckboxListThemeData = () => {
  return {
    checkboxList: {
      title: {
        defaultColor: "#cccccc",
        borderBottomColor: "rgb(23, 23, 23)",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#2c2c2c"
      }
    }
  };
};

const computeDrawerThemeData = () => {
  return {
    drawer: {
      header: {
        backgroundColor: "#0a0a0a"
      },
      area: { background: baseSIThemeData.backgrounds.mainBG },
      box: { background: baseSIThemeData.backgrounds.boxBG }
    }
  };
};

const getHeaderButtonPcStyles = () => {
  return {
    ...baseSIThemeData,
    typography: {
      ...baseSIThemeData.typography,
      fontFamilyBold: "IndustryBold",
      fontSize: `1.6rem`,
      fontWeight: 400
    },
    colors: {
      ...baseSIThemeData.colors,
      outlinedBorderColor: "#e63422"
    },
    backgrounds: {
      ...baseSIThemeData.backgrounds,
      hoverColorOutlined: "#e63422"
    },
    borders: {
      ...baseSIThemeData.borders,
      borderColor: "#FFFFFF"
    }
  };
};

const computeLinkButtonThemeData = () => {
  return {
    linkButtonTitle: {
      defaultColor: "#cccccc",
      borderBottomColor: "rgb(23, 23, 23)",
      boxShadow: "0px 1px 0px 0px",
      boxShadowColor: "#2c2c2c"
    },
    linkButton: {
      icon: { defaultColor: baseSIThemeData.colors.iconColor },
      title: { defaultColor: baseSIThemeData.colors.textColor },
      description: {
        defaultColor: "#717171"
      },
      arrow: {
        defaultColor: "#ffffff"
      }
    }
  };
};

const computeLinkItemThemeData = () => {
  return {
    linkItem: {
      icon: { defaultColor: baseSIThemeData.colors.iconColor }
    }
  };
};

const computePopupThemeData = () => {
  return {
    popupButton: {
      fontFamily: "defaultBold",
      dotsFloatingBackgroundColor: "#0A0A0A",
      outlined: {
        background: "#e63422",
        backgroundColor: "#000000",
        color: "#ffffff",
        borderColor: "#6c6c6c",
        hover: {
          backgroundColor: "#000000",
          color: "#ffffff",
          borderColor: "#ffffff"
        }
      },
      contained: {
        background: "#e63422",
        color: "#ffffff",
        borderColor: "#e63422",
        hover: {
          background: "#000000",
          color: "#e63422",
          borderColor: "#e63422"
        }
      },
      underlined: {
        color: "#ffffff",
        hover: {
          background: "none",
          color: "#ffffff"
        }
      }
    },
    popupContainer: {
      textColor: "#ffffff",
      subtitleColor: "#ffffff",
      message: {
        color: "#fc6200"
      },
      zIndex: 200,
      backgroundColor: "#111111",
      titleBackgroundColor: "#232323",
      iconColor: "#ffffff",
      pokerDownloadGuide: {
        titleWrapperColor: "#e63422",
        underlineTextWrapperColor: "#e63422",
        svgWrapperColor: "#ffffff"
      }
    },
    popupFooter: {
      fontFamily: "defaultMedium",
      color: "#a5a5a5"
    }
  };
};

const computeControlCenterThemeData = () => {
  return {
    controlCenter: {
      headerButton: {
        backgroundColor: "#121212",
        borderColor: "#4c4c4c",
        svgBackgroundColor: "#6c6c6c"
      }
    }
  };
};

const computeLanguagesDrawerThemeData = () => {
  return {
    languagesDrawer: {
      fontFamily: "IndustryBook",
      checkedOptionBackgroundColor: "e63422",
      backgroundColor: "#171717",
      textColor: "#FFFFFF"
    }
  };
};

export const SIThemeData = {
  getHeaderButtonPcStyles,
  ...baseSIThemeData,
  ...computePanelThemeData(),
  ...computeExpandablePanelThemeData(),
  ...computeDrawerThemeData(),
  ...computeListThemeData(),
  ...computeCheckboxListThemeData(),
  ...computeLinkButtonThemeData(),
  ...computeLinkItemThemeData(),
  ...computePopupThemeData(),
  ...computeControlCenterThemeData(),
  ...computeLanguagesDrawerThemeData()
};
